/**
 * 
 * Build changes:
 *  - v34.2.0 - APEX 22.2
 *      - no big changes
 *  - v34.0.0
 *      - New packages: sourceEditing, htmlSupport
 *  - v32.0.0 - APEX 22.1
 * 		- Major change: Now exposing CKEditor5 & all its packages as opposed to ClassicEditor & selective packages
 * 		- Widget CSS now goes in its own file. ck-content styles are extracted and put into apex_ui for easier overriding
 *  - v30.0.0
 * 		- no big changes
 * 	- v29.2.0
 * 		- no big changes
 *  - v29.1.0
 *  	- New package: minimap. Experimental, not including it yet
 *  - v29.0.0
 *  	- New package: findAndReplace. Still has some bugs so not including it yet
 * 		- New packages: sourceEditing, htmlSupport. Not included yet. Only include when moving to DDLs
 *  - v28.0.0
 * 		- New package: tableCaption
 *  - v27.1.0 - APEX 21.1
 *  - v21.0.0 - APEX 20.2
 * 
 * Changes that impact the RTE page item should be logged in images/libraries/apex/widget.ckeditor5.js
 * 
 * Not including Premium packages:
 *  - cloudServicesCollaboration
 * 	- cloudServices
 *  - collaborationCore
 *  - comments
 *  - easyImage
 *  - exportPdf
 *  - exportWord
 *  - pagination
 *  - realTimeCollaboration
 *  - revisionHistory
 *  - trackChanges
 *  - watchDog
 *  - @webspellchecker/wproofreader-ckeditor5 - Proofreading, spelling and grammar checking
 *  - @wiris/mathtype-ckeditor5 - Math equations and chemical formulas
 * 
 * Not needed by APEX:
 *  - markdownGfm - we implement our own
 *  - react
 *  - editorBalloon, editorDecoupled, editorInline as we only ship editorClassic
 * 
 * Not including dev only packages:
 *  - any of the dev[Docs|Env|Utils|WebpackPlugin] packages
 *  - themeLark
 * 
 */

import * as adapterCkfinder from '@ckeditor/ckeditor5-adapter-ckfinder/src/index';
import * as alignment from '@ckeditor/ckeditor5-alignment/src/index';
import * as autoformat from '@ckeditor/ckeditor5-autoformat/src/index';
import * as autosave from '@ckeditor/ckeditor5-autosave/src/index';
import * as basicStyles from '@ckeditor/ckeditor5-basic-styles/src/index';
import * as blockQuote from '@ckeditor/ckeditor5-block-quote/src/index';
import * as ckfinder from '@ckeditor/ckeditor5-ckfinder/src/index';
import * as clipboard from '@ckeditor/ckeditor5-clipboard/src/index';
import * as codeBlock from '@ckeditor/ckeditor5-code-block/src/index';
import * as core from '@ckeditor/ckeditor5-core/src/index';
import * as editorClassic from '@ckeditor/ckeditor5-editor-classic/src/index';
import * as engine from "@ckeditor/ckeditor5-engine/src/index";
import * as enter from "@ckeditor/ckeditor5-enter/src/index";
import * as essentials from '@ckeditor/ckeditor5-essentials/src/index';
import * as findAndReplace from '@ckeditor/ckeditor5-find-and-replace/src/index';
import * as font from '@ckeditor/ckeditor5-font/src/index';
import * as heading from '@ckeditor/ckeditor5-heading/src/index';
import * as highlight from '@ckeditor/ckeditor5-highlight/src/index';
import * as horizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/index';
import * as htmlEmbed from '@ckeditor/ckeditor5-html-embed/src/index';
import * as htmlSupport from '@ckeditor/ckeditor5-html-support/src/index';
import * as image from '@ckeditor/ckeditor5-image/src/index';
import * as indent from '@ckeditor/ckeditor5-indent/src/index';
import * as language from '@ckeditor/ckeditor5-language/src/index';
import * as link from '@ckeditor/ckeditor5-link/src/index';
import * as list from '@ckeditor/ckeditor5-list/src/index';
import * as markdown from './apex-markdown-gfm/src/index';
import * as mediaEmbed from '@ckeditor/ckeditor5-media-embed/src/index';
import * as mention from '@ckeditor/ckeditor5-mention/src/index';
import * as minimap from '@ckeditor/ckeditor5-minimap/src/index';
import * as pageBreak from '@ckeditor/ckeditor5-page-break/src/index';
import * as paragraph from '@ckeditor/ckeditor5-paragraph/src/index';
import * as pasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/index';
import * as removeFormat from '@ckeditor/ckeditor5-remove-format/src/index';
import * as restrictedEditing from '@ckeditor/ckeditor5-restricted-editing/src/index';
import * as selectAll from "@ckeditor/ckeditor5-select-all";
import * as sourceEditing from '@ckeditor/ckeditor5-source-editing/src/index';
import * as specialCharacters from '@ckeditor/ckeditor5-special-characters/src/index';
import * as table from '@ckeditor/ckeditor5-table/src/index';
import * as typing from '@ckeditor/ckeditor5-typing/src/index';
import * as ui from '@ckeditor/ckeditor5-ui/src/index';
import * as undo from "@ckeditor/ckeditor5-undo";
import * as upload from '@ckeditor/ckeditor5-upload/src/index';
import * as utils from '@ckeditor/ckeditor5-utils/src/index';
import * as widget from "@ckeditor/ckeditor5-widget/src/index";
import * as wordCount from '@ckeditor/ckeditor5-word-count/src/index';

const CKEditor5 = {
    adapterCkfinder,
    alignment,
    autoformat,
    autosave,
    basicStyles,
    blockQuote,
    ckfinder,
    clipboard,
    codeBlock,
    core,
    editorClassic,
    engine,
    enter,
    essentials,
    // findAndReplace,
    font,
    heading,
    highlight,
    horizontalLine,
    htmlEmbed,
    htmlSupport,
    image,
    indent,
    language,
    link,
    list,
    markdown,
    mediaEmbed,
    mention,
    // minimap,
    pageBreak,
    paragraph,
    pasteFromOffice,
    removeFormat,
    restrictedEditing,
    selectAll,
    sourceEditing,
    specialCharacters,
    table,
    typing,
    ui,
    undo,
    upload,
    utils,
    widget,
    wordCount
};

export default CKEditor5;